import React from 'react';
import { Field } from 'react-final-form';






export const Condition = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => (value === is ? children : null)}
  </Field>
);



// Condition used in UserContactForm.js to enable user to view the option to create a mass notification contact if the launch code from Onsolve is added to system parameters
export const ConditionMassnotificationSysParams = ({massnotificationSysParams, children}) => (
  <Field name={'massnotificationSysParams'} subscription={{ value: true }}>
    {({ input: { value } }) => (massnotificationSysParams != null ? children : null)}
  </Field>
);

